import Vue from "vue";
import Component from "vue-class-component";
import {Watch} from "vue-property-decorator";
import {Route} from "vue-router";
import { isEqual } from "lodash-es";

export const WatchRoute = (target: string) =>  {
  @Component({name: "WatchRoute"})
  class WatchQuery extends Vue {
    @Watch("$route", { immediate: true })
    public __onRouteChanged(newRoute: Route, oldRoute: Route) {
      if (!isEqual(newRoute, oldRoute)) {
        const vm = this as any;
        if (typeof vm[target] !== "function") {
          throw new Error ("WatchRoute: target should be function");
        }
        vm[target](newRoute, oldRoute);
      }
    }
  }
  return WatchQuery;
};
